export enum SumsubReviewStatus {
  INIT = 'init',
  PENDING = 'pending',
  PRE_CHECKED = 'prechecked',
  QUEUED = 'queued',
  COMPLETED = 'completed',
  ON_HOLD = 'onHold',
  AWAITING_SERVICE = 'awaitingService', // onHold (waiting for external processing (e.g. database queries, service completion))
  AWAITING_USER = 'awaitingUser', // onHold (waiting for user action beyond document submission (e.g. associated parties verification))
}

export const SUMSUB_REVIEW_STATUSES = Object.values(SumsubReviewStatus);

export enum SumsubReviewAnswer {
  GREEN = 'GREEN',
  RED = 'RED',
}

export const SUMSUB_REVIEW_ANSWERS = Object.values(SumsubReviewAnswer);

export enum SumsubReviewRejectType {
  FINAL = 'FINAL',
  RETRY = 'RETRY',
}

export const SUMSUB_REVIEW_REJECT_TYPES = Object.values(SumsubReviewRejectType);
